<div class="hamburger {{ classes }}" porClickOutside>
    @if (btnimg) {
    <img class="img-burger" (click)="openPanel()" [src]="btnimg" />
    } @else {
    <por-base-button [featureName]="'csv-button'" [class]="'theme-button csv-button'" (onclick)="openPanel()" [icon]="(isOpened$ | async) ? 'close' : icon" iconClass="mat-18"></por-base-button>
    }
    <div class="{{ panelClass }} hamburger-items" [ngClass]="{ active: (isOpened$ | async) }">
        @if (logo.length > 0 && closeOnPanel) {
        <div class="hamburger-mob-heading">
            <a (click)="openHomepage()" href="javascript:void(0)">
                @if (logo.length > 0) {
                <img [src]="logo" />
                }
            </a>
            @if (closeOnPanel) {
            <por-base-button [featureName]="'close-on-panel'" (click)="closePanel()" icon="close"></por-base-button>
            }
        </div>
        }
        <ng-content></ng-content>
    </div>
</div>
